import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { IRulesetCreateParams } from '../../../types/ruleset-types';

interface CreateRulesetParams {
  dataPoolId: string;
  data: IRulesetCreateParams;
}

export function useCreateRuleset(callbacks?: IRQCallbacks) {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ dataPoolId, data }: CreateRulesetParams) =>
      (await glynt).ruleset.create(dataPoolId, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['rulesets', variables.dataPoolId] });
      callbacks?.onSuccess?.(data);
    },
    onError: callbacks?.onError,
    onMutate: callbacks?.onMutate,
    onSettled: callbacks?.onSettled,
  });
}
